import { useState, useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Reads the current user's role from the Cognito ID token payload (custom:role claim).
 */
export const useUserRole = () => {
  const [role, setRole] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    fetchAuthSession()
      .then((session) => {
        const payload = session.tokens?.idToken?.payload;
        const userRole = (payload?.['custom:role'] as string) ?? null;
        const id = (payload?.['custom:user_id'] as string) ?? null;
        if (mounted) {
          setRole(userRole);
          setUserId(id);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (mounted) {
          setRole(null);
          setUserId(null);
          setIsLoading(false);
        }
      });
    return () => {
      mounted = false;
    };
  }, []);

  return {
    role,
    isLoading,
    userId,
    isTechnician: role === 'TECHNICIAN',
    isClient: role === 'CLIENT',
    isAdmin: role === 'ADMIN' || role === 'SUPER_ADMIN',
    isSuperAdmin: role === 'SUPER_ADMIN',
  };
};
